import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  manufacturerHintsTitle: {
    id: 'manufacturerHints.title',
    defaultMessage: 'Produktverantwortlich in der EU',
  },
  manufacturerHintsManufacturer: {
    id: 'manufacturerHints.manufacturer',
    defaultMessage: 'Hersteller',
  },
  manufacturerHintsAddress: {
    id: 'manufacturerHints.address',
    defaultMessage: 'Postanschrift',
  },
  manufacturerHintsEmail: {
    id: 'manufacturerHints.email',
    defaultMessage: 'Elektronische Adresse',
  },
});
